import { AuditInfoModel } from '../policy/model'
import SettingBaseApi from './base'
import { PolicyItemModel } from './module'
class PolicyApi extends SettingBaseApi {
  getPolicyList(ruleType = '1', conditionType: any, activeStatus: any, page = 1, pageSize = 100) {
    return this.post<PolicyItemModel[]>('/ruleTransaction/list', {
      ruleType,
      conditionType,
      activeStatus,
      page,
      pageSize,
    })
  }
  getAuditorInfoByModifyKey(modifyKey: string) {
    return this.post<AuditInfoModel>('/audit/getAuditorInfoByModifyKey', { modifyKey })
  }
}
export default new PolicyApi()
